import React from 'react';
import InternalPortal from './internal/components/internal-portal';
import useIsSubsequentRender from './internal/hooks/use-is-subsequent-render';
import useFirePortalEvent from './internal/hooks/use-portal-event';
export default function Portal(props) {
  const {
    zIndex = 0,
    children
  } = props;
  const isSubsequentRender = useIsSubsequentRender();
  useFirePortalEvent(zIndex);
  return isSubsequentRender ? /*#__PURE__*/React.createElement(InternalPortal, {
    zIndex: zIndex
  }, children) : null;
}